<template>
    <div class="staff-layout">
        <AppHeader />

        <main>
            <router-view v-slot="{ Component }">
                <keep-alive :include="cachedRoutes">
                    <component :is="Component" />
                </keep-alive>
            </router-view>
        </main>

        <LoadingOverlay />
        <ConfirmOverlay />
        <NotifyOverlay />
    </div>
</template>

<script setup>
    import AppHeader from '@/components/common/headers/StaffHeader.vue'
    import LoadingOverlay from '@/components/common/overlays/LoadingOverlay.vue'
    import ConfirmOverlay from '@/components/common/overlays/ConfirmOverlay.vue'
    import NotifyOverlay from '@/components/common/overlays/NotifyOverlay.vue'

    import { useRouteCache } from "@/utils/routeCache";

    /* cache tối đa 5 route */
    const { cachedRoutes } = useRouteCache(5);
</script>

<style scoped>
    main {
        padding: 16px;
    }
</style>